import React, { useEffect, useState } from "react";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { useNavigate } from "react-router-dom";
import { purchaseList } from "../../Services/Operations/ProductAPI";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux"; 

const PurchaseBillList = () => {
  const [purchases, setPurchases] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);

            const [currentPage, setCurrentPage] = useState(1);
                const itemsPerPage = 10;
                
                const indexOfLast = currentPage * itemsPerPage;
                const indexOfFirst = indexOfLast - itemsPerPage;
                
                const currentBill = purchases.slice(indexOfFirst, indexOfLast);

  const handleViewDetails = (purchase) => {
    setSelectedPurchase(purchase);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedPurchase(null);
  };

  useEffect(() => {
    const fetchPurchaseList = async () => {
      try {
        const response = await purchaseList(token);
        console.log("response1 : ", response);
        setPurchases(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchPurchaseList();
  }, []);

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Purchase List</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Purchases
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Dep-all">
                <div className="table-responsive">
                  {/* <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-6">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Bill No."
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Vendor Name"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="GST Number"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                          <div className="input-group">
                            <input
                              data-provide="datepicker"
                              data-date-autoclose="true"
                              className="form-control"
                              placeholder="Purchase Date"
                            />
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                          <a
                            href="javascript:void(0);"
                            className="btn btn-sm btn-primary btn-block"
                            title
                          >
                            Search
                          </a>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="table-responsive card">
                    <table className="table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                      <thead>
                        <tr>
                          <th style={{textAlign:"center"}}>ID</th>
                          <th style={{textAlign:"center"}}>Bill No.</th>
                          <th style={{textAlign:"center"}}>Vendor Name</th>
                          <th style={{textAlign:"center"}}>GST Number</th>
                          <th style={{textAlign:"center"}}>Purchase Date</th>
                          <th style={{textAlign:"center"}}>Grand Total</th>
                          <th style={{textAlign:"center"}}>Status</th>
                          <th style={{textAlign:"center"}}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentBill.map((purchase,index) => (
                          <tr key={purchase.id}>
                            <td>{indexOfFirst+index+1}</td>
                            <td>{purchase.billNo}</td>
                            <td>{purchase.vendorName || "N/A"}</td>
                            <td>{purchase.vendorGstNumber || "N/A"}</td>
                            <td>
                              {new Date(
                                purchase.purchaseDate
                              ).toLocaleDateString()}
                            </td>
                            <td>₹{purchase.grandTotal}</td>
                            <td>
                              {purchase.status === 0 ? (
                                <span className="badge badge-warning">
                                  Pending
                                </span>
                              ) : (
                                <span className="badge badge-success">
                                  Completed
                                </span>
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-icon btn-sm"
                                title="View"
                                onClick={() => handleViewDetails(purchase)}
                              >
                                <i className="fa fa-eye" />
                              </button>
                             
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                         <div className="pagination mt-3" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                             <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    className="btn btn-primary btn-sm me-2"
  >
    Prev
                     </button>

                      <span> Page {currentPage} of {Math.ceil(purchases.length / itemsPerPage)} </span>

                  <button
    disabled={currentPage === Math.ceil(purchases.length / itemsPerPage)}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    className="btn btn-primary btn-sm ms-2"
  >
    Next
               </button>
                                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Purchase Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedPurchase && (
              <div>
                <p>
                  <strong>ID:</strong> {selectedPurchase.id}
                </p>
                <p>
                  <strong>Bill No.:</strong> {selectedPurchase.billNo}
                </p>
                <p>
                  <strong>Vendor Name:</strong>{" "}
                  {selectedPurchase.vendorName || "N/A"}
                </p>
                <p>
                  <strong>GST Number:</strong>{" "}
                  {selectedPurchase.vendorGstNumber || "N/A"}
                </p>
                <p>
                  <strong>Purchase Date:</strong>{" "}
                  {new Date(selectedPurchase.purchaseDate).toLocaleDateString()}
                </p>
                <p>
                  <strong>Grand Total:</strong> ₹{selectedPurchase.grandTotal}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  {selectedPurchase.status === 0 ? "Pending" : "Completed"}
                </p>
                <p>
                  <strong>Sub Total:</strong> ₹
                  {selectedPurchase.subTotal || "N/A"}
                </p>
                <p>
                  <strong>Payable Amount:</strong> ₹
                  {selectedPurchase.payableAmount || "N/A"}
                </p>
                <p>
                  <strong>Due Amount:</strong> ₹
                  {selectedPurchase.dueAmount || "N/A"}
                </p>
                <p>
                  <strong>Payment Mode:</strong>{" "}
                  {selectedPurchase.paymentMode || "N/A"}
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PurchaseBillList;
